import { CustomCollapseCard, Text } from '@src/components';
import { moneyFormat } from '@src/utils/utils';
import dayjs from '@src/utils/day';
import { monthsList, orderTypeList } from '@src/store/enums';
import { useSelector } from 'react-redux';
import '@src/styles/balanceUpload/orderSummaryInformation.scss';

const OrderSummaryInformationCompliments = () => {
  const { currentLoadBalance } = useSelector((state) => state?.balanceUpload);

  const invoiceMonthText = monthsList
    .filter((month) => month.value === currentLoadBalance?.invoiceMonth)
    .reduce((acc, month) => month.text, '');

  return (
    <CustomCollapseCard
      cardTitle={<Text t="orderSummaryTitle" />}
      cardTitleAlign="center"
      titleColor="#1d2228"
      titleSize="16px"
      showExpandIcon={false}
    >
      <div className="balance-upload-summary-container">
        <div className="order-summary-col-1">
          <div className="title" style={{ width: '100%' }}>
            <b><Text t="orderType" />:</b>{' '}
            <span>
              {orderTypeList.filter((oTL) => oTL.value === currentLoadBalance?.orderType)[0].text}
            </span>
          </div>
          <div className="title" style={{ width: '100%' }}>
            <b><Text t="autoActivationDate" />:</b>
            <b style={{ color: '#f66301' }}>
              <span style={{ color: '#f66301' }}>
                {dayjs(currentLoadBalance?.activationDate).format('D MMMM YYYY')}
              </span>
            </b>
          </div>
        </div>
        <div className="order-summary-col-2">
          <div className="title" style={{ width: '100%' }}>
            <b>
              <Text t="invoiceMonth2" />
            </b>{' '}
            <span>{invoiceMonthText}</span>
          </div>
          <div className="title" style={{ width: '100%' }}>
            <b>
              <Text t="invoiceAddress" />
            </b>{' '}
            <span>{currentLoadBalance?.invoiceAddress}</span>
          </div>
          <div className="title e-invoice-information">
            <b>
              <Text t="eInvoiceAdditionalInformation2" />
            </b>{' '}
            <span>{currentLoadBalance?.eInvoiceInformation}</span>
          </div>
        </div>
        <div className="order-summary-col-2" style={{ borderRightWidth: 0 }}>
          <div className="title">
            <b><Text t="numberOfCards3" />:</b>
            <span>
              <b style={{ marginLeft: 5, color: '#f66301' }}>{currentLoadBalance?.totalCount}</b>
            </span>
          </div>
          <div className="title">
            <b><Text t="totalBalanceToBeLoadedUpperCaseColon" />:</b>
            <b style={{ marginLeft: 5, color: '#f66301' }}>
              {moneyFormat(currentLoadBalance?.totalPrice, true)}
            </b>
          </div>
          <div className="title">
            <b><Text t="totalAmountToBePaid" />:</b>
            <b style={{ marginLeft: 5, color: '#f66301' }}>
              {moneyFormat(currentLoadBalance?.totalPaymentAmount, true)}
            </b>
          </div>
        </div>
      </div>
    </CustomCollapseCard>
  );
};

export default OrderSummaryInformationCompliments;
